exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training_statement_word {\n  float: left;\n  border: 1px solid lightgrey;\n  padding: 5px 10px;\n  border-radius: 10px;\n  min-height: 35px;\n  cursor: pointer;\n  background: lightgray;\n  margin-left: 5px;\n  margin-bottom: 10px;\n}", ""]);

// exports
